import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomButton, SpinElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './notifications.scss';

// Components
import { NotificationList } from '../../shared/components/notifications';
import { ClearNotificationsModal } from '../../modals/clear-notifications-modal/clear-notifications-modal';

// Store entities
import {
  clearNotifications,
  deleteNotifications,
  getNotifications, markAsReadNotifications
} from '../../store/notifications/notifications.thunks';
import { getNotificationsState } from '../../store/notifications/notifications.selectors';

type TNotificationsProps = {};

export const Notifications: FC<TNotificationsProps> = (
  {}: TNotificationsProps
) => {

  const [deletingNotification, setDeletingNotification] = useState<boolean>(false);
  const [clearAllOpen, setClearAllOpen] = useState<boolean>(false);

  const {
    list,
    loading,
    total
  } = useSelector(getNotificationsState);

  const dispatch = useDispatch<any>();

  const loadNotifications = async (isFirstLoad: boolean = false): Promise<void> => {
    await dispatch(getNotifications({
      offset: list.length,
      isFirstLoad
    }));
    dispatch(markAsReadNotifications());
  }

  const loadMoreHandler = (): void => {
    loadNotifications(false);
  }

  const toggleClearAllModal = (): void => {
    setClearAllOpen(!clearAllOpen);
  }

  const clearAllNotification = async (): Promise<void> => {
    toggleClearAllModal();
    setDeletingNotification(true);
    await dispatch(deleteNotifications({}));
    setDeletingNotification(false);
  }

  useEffect(() => {
    loadNotifications(true);

    return () => {
      dispatch(clearNotifications());
    };
  }, []);

  return (
    <div className="notifications">
      <ClearNotificationsModal open={ clearAllOpen } onCancel={ toggleClearAllModal }
                               onSubmit={ clearAllNotification }/>
      <div className="notifications--header">
        <div className="header-title">
          Notifications
        </div>
        { total > 0 && <div className="header-actions">
          <CustomButton loading={ deletingNotification } text={ 'Clear All' } onClick={ toggleClearAllModal }/>
        </div> }
      </div>

      {
        loading &&
        <div className={ `notifications--loader notifications--loader-${ loading ? 'show' : 'hide' }` }>
          <SpinElement fullHeight={ true }/>
        </div>
      }

      { !!total && <div className="notifications--body">
        <NotificationList notifications={ list } total={ total } loading={ loading } loadMore={ loadMoreHandler }/>
      </div> }

      { (!total && !loading) && <div className="notifications--empty">
        You don’t have any notifications.
      </div> }
    </div>
  );
}
